import { mapActions, mapGetters } from 'vuex'
import validationMixin from '@/mixins/validation'
import MainEditor from '@/components/editor/index.vue'
import { selectedModule } from '@/mixins/index'
export default {
  name: 'content-form',
  mixins: [validationMixin],
  props: {
    locale: {
      type: String
    },
    newsStatuses: {
      type: Array
    }
  },
  data () {
    return {
      payload: {
        title: '',
        shortContent: '',
        content: '',
        locale: '',
        status: ''
      },
      valid: false,
      openDatepicker: false,
      validationErrors: {}
    }
  },
  components: {
    MainEditor
  },
  computed: {
    ...mapGetters({
      content: 'newsContent/content',
      contentLoading: 'newsContent/contentLoading',
      contentUpdateLoading: 'newsContent/contentUpdateLoading',
      accessCountries: 'profile/accessCountries'
    })
  },
  created () {
    this.setContent()
  },
  methods: {
    ...mapActions({
      update: 'newsContent/CONTENT_UPDATE_DATA',
      create: 'newsContent/CONTENT_CREATE_DATA'
    }),
    setContent () {
      this.payload.locale = this.locale
      const data = this.content.content.find(e => e.locale === this.payload.locale)
      if (data) {
        Object.assign(this.payload, data)
      }
    },
    createRequestPayload () {
      let data
      const item = this.content.content.find(e => e.locale === this.payload.locale)
      if (!item) {
        data = {
          locale: this.payload.locale,
          contentable_type: selectedModule({ module: this.$route.name }),
          contentable_id: this.content.id,
          status: this.payload.status,
          title: this.payload.title,
          short_content: this.payload.shortContent,
          content: this.payload.content
        }
      } else {
        data = {
          id: item.id,
          status: this.payload.status,
          title: this.payload.title,
          short_content: this.payload.shortContent,
          content: this.payload.content
        }
      }
      return data
    },
    submit () {
      this.$refs.form.validate()
      if (this.valid) {
        const item = this.content.content.find(e => e.locale === this.payload.locale)
        if (!item) {
          this.create({
            ...this.createRequestPayload(),
            module: this.$route.name
          }).then(() => {
            this.$toasted.success(this.$t('newsSuccessCreateContent'))
          })
        } else {
          this.update({
            ...this.createRequestPayload(),
            module: this.$route.name
          }).then(() => {
            this.$toasted.success(this.$t('newsSuccessUpdateContent'))
          })
        }
      }
    }
  }
}
